interface RadarData {
  dimension: string
  source: number
  market_avg: number
}

export function RadarChart({ data }: { data: RadarData[] }) {
  const n = data.length
  if (n < 3) return null
  const cx = 120, cy = 120, r = 90
  const angle = (i: number) => (Math.PI * 2 * i) / n - Math.PI / 2

  const toPoint = (i: number, val: number) => ({
    x: cx + r * (val / 100) * Math.cos(angle(i)),
    y: cy + r * (val / 100) * Math.sin(angle(i)),
  })

  const mkPolygon = (values: number[], stroke: string, fill: string) => {
    const points = values.map((v, i) => toPoint(i, v))
    return <polygon points={points.map(p => `${p.x},${p.y}`).join(' ')} fill={fill} stroke={stroke} strokeWidth="2" />
  }

  return (
    <div className="flex justify-center">
      <svg width="240" height="260" viewBox="0 0 240 260">
        {[20, 40, 60, 80, 100].map(v => (
          <polygon key={v} points={data.map((_, i) => toPoint(i, v)).map(p => `${p.x},${p.y}`).join(' ')} fill="none" stroke="#e5e7eb" strokeWidth="0.5" />
        ))}
        {data.map((_, i) => {
          const p = toPoint(i, 100)
          return <line key={i} x1={cx} y1={cy} x2={p.x} y2={p.y} stroke="#e5e7eb" strokeWidth="0.5" />
        })}
        {mkPolygon(data.map(d => d.market_avg), '#94a3b8', 'rgba(148,163,184,0.15)')}
        {mkPolygon(data.map(d => d.source), '#f97316', 'rgba(249,115,22,0.2)')}
        {data.map((d, i) => {
          const p = toPoint(i, 110)
          return <text key={i} x={p.x} y={p.y} textAnchor="middle" className="text-2xs fill-neutral-500">{d.dimension}</text>
        })}
        <rect x="60" y="245" width="12" height="3" fill="#f97316" rx="1" />
        <text x="76" y="249" className="text-3xs fill-neutral-500">Source</text>
        <rect x="120" y="245" width="12" height="3" fill="#94a3b8" rx="1" />
        <text x="136" y="249" className="text-3xs fill-neutral-500">Market Avg</text>
      </svg>
    </div>
  )
}
